export enum AnswerTemplateType {
  AllAgent = 'all-agent',
  GroupAgent = 'group-agent',
  OnlyMe = 'only-me',
  Agent = 'agents',
}
export const AnswerTemplateTypeArr = [
  { id: AnswerTemplateType.AllAgent, text: 'Tất cả chuyên viên' },
  {
    id: AnswerTemplateType.GroupAgent,
    text: 'Tất cả chuyên viên thuộc bộ phận',
  },
  { id: AnswerTemplateType.Agent, text: 'Chỉ các chuyên viên' },
  { id: AnswerTemplateType.OnlyMe, text: 'Chỉ mình tôi' },
];
export class AnswerTemplateConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên mẫu trả lời',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Đối tượng sử dụng',
        key: 'display_access_type',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static displayTypeColumn = template => {
    let html = `<span>`;
    switch (template.access_type) {
      case AnswerTemplateType.AllAgent:
        return `<span class="badge badge-default">Toàn bộ chuyên viên</span>`;
      case AnswerTemplateType.GroupAgent:
        if (Array.isArray(template.access_ids) && template.access_ids.length > 0) {
          template.access_ids.forEach(access => {
            if (access.label) {
              html += `<span class="badge badge-warning mr-5" title="bộ phận">` + access.label + `</span>`;
            }
          });
        }
        return html + `</span>`;
      case AnswerTemplateType.Agent:
        if (Array.isArray(template.access_ids) && template.access_ids.length > 0) {
          template.access_ids.forEach(access => {
            if (access.label) {
              html += `<span class="badge badge-info mr-5" title="chuyên viên">` + access.label + `</span>`;
            }
          });
        }
        return html + `</span>`;
      case AnswerTemplateType.OnlyMe:
        return `<span class="badge badge-default">Chỉ mình tôi</span>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/answertemplate/answer-template.const.ts